/**
 * This module contains functions relating to forms/questionnaires/surveys.
 */
const sameKeyValue = value => [value, value]
const arrayToKeyValue = options => Object.fromEntries(options.map(sameKeyValue))

export { arrayToKeyValue }
